import AppointmentRecapNotes from 'pages/Appointments/components/AppointmentRecapNotes';
import React, { useEffect } from 'react';
import { Route, Switch, useParams, useRouteMatch } from 'react-router-dom';
import { useTopToolbarContext } from 'shared/components/Layouts/DefaultAuthenticated/components/TopToolbar/context/TopToolbarContext';
import Appointments from '.';

const RecapWrapper: React.FC = () => {
  const { appointmentId } = useParams<{ appointmentId: string }>();
  const { setOverridePageName } = useTopToolbarContext();
  useEffect(() => {
    // Even though this component will be accessed via an appointment route
    // we want to override the page name to "AI Recap" for clarity.
    setOverridePageName('AI Recap');
    return (): void => {
      setOverridePageName(undefined);
    };
  }, [setOverridePageName]);
  return appointmentId ? <AppointmentRecapNotes appointmentId={appointmentId} /> : null;
};

const AppointmentsRouter: React.FC = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/:appointmentId/recap`} component={RecapWrapper} />
      <Route path={path} component={Appointments} />
    </Switch>
  );
};

export default AppointmentsRouter;
